import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { APIUtilService } from './_util/api-util.service';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { AuthAPIService } from './_api/auth-api.service';
import { IsLoggedInGuard } from './_guard/is-logged-in.guard';
import { IsNotLoggedInGuard } from './_guard/is-not-logged-in.guard';
import { AuthUtilService } from './_util/auth-util.service';
import { TokenInterceptorService } from './_util/token-interceptor.service';

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
  ],
  providers: [
    IsLoggedInGuard,
    IsNotLoggedInGuard,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptorService,
      multi: true
    },
    AuthUtilService,
    AuthAPIService,
    APIUtilService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
